import { DEAL_CLOSED_STATUSES, DEAL_WON_STATUSES, TODAY } from '../../constants';
import { isoStr } from '../../utils/dates';
import { blankDealLine } from './dealLineDefaults';

// Nouvelle affaire, éventuellement déjà rattachée à un client.
export const emptyDeal = (presetClientId) => ({
  nom: '',
  client_id: presetClientId || '',
  type_projet: '',
  statut: 'a_travailler',
  lignes: [blankDealLine()],
  responsable_id: '',
  motif_perte: '',
  description: '',
  notes: '',
});

// Champs enregistrés d'une affaire ; le motif de perte n'est gardé que pour un statut clos.
export const dealRow = (m, clientId) => ({
  nom: m.nom.trim(),
  client_id: clientId,
  type_projet: m.type_projet || null,
  statut: m.statut,
  responsable_id: m.responsable_id || null,
  motif_perte: DEAL_CLOSED_STATUSES.includes(m.statut) ? m.motif_perte || null : null,
  description: m.description || null,
  notes: m.notes || null,
});

// Date de signature d'une affaire qui devient gagnée : posée au premier passage dans un statut
// gagné (« Devis accepté », « En cours » ou « Terminé »), à la création comme en cours de vie.
// Sans elle, le forfait n'apparaît dans aucune année des chiffres par année.
export function acceptedDatePatch(prev, newStatus) {
  if (!DEAL_WON_STATUSES.includes(newStatus) || prev?.date_devis_accepte) return {};
  return { date_devis_accepte: isoStr(TODAY) };
}

// Date de clôture : posée au (dernier) passage dans « Suspendu », « Sans suite » ou « Non retenu »,
// vidée quand l'affaire repasse en vente ou en gagné. Range l'affaire dans son année de clôture.
export function decisionDatePatch(prev, newStatus) {
  if (prev?.statut === newStatus) return {};
  if (DEAL_CLOSED_STATUSES.includes(newStatus)) return { date_decision: isoStr(TODAY) };
  return prev?.date_decision ? { date_decision: null } : {};
}

// Dates posées par un changement de statut, quel que soit le chemin (fiche, kanban, liste,
// conversion, clôture de phase).
export const statusDatesPatch = (prev, newStatus) => ({
  ...acceptedDatePatch(prev, newStatus),
  ...decisionDatePatch(prev, newStatus),
});

// Dates saisies dans la fiche (« Signée le », « Clôturée le ») : elles priment sur la date posée
// automatiquement, chacune seulement dans sa famille de statuts (une affaire repassée en vente ne
// garde pas de date de clôture).
export const manualStatusDates = (m) => ({
  ...(DEAL_WON_STATUSES.includes(m.statut) && m.date_devis_accepte
    ? { date_devis_accepte: m.date_devis_accepte }
    : {}),
  ...(DEAL_CLOSED_STATUSES.includes(m.statut) && m.date_decision
    ? { date_decision: m.date_decision }
    : {}),
});

// Une affaire qui devient gagnée (« Devis accepté », « En cours » ou « Terminé ») fait passer son
// contact en « Actif » (client). Seulement au passage : le statut reste modifiable à la main.
export const becomesWon = (prev, newStatus) =>
  DEAL_WON_STATUSES.includes(newStatus) && !DEAL_WON_STATUSES.includes(prev?.statut);
